import { createApiRef, OAuthApi, SessionApi } from '@backstage/core-plugin-api';

export const microsoftAzUserAuthApiRef = createApiRef<OAuthApi & SessionApi>({
  id: 'auth.microsoft-az-user',
});
